// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"97878465","998":"c88cd98c"}[chunkId] + ".chunk.js";
};